import { Component, Input } from "@angular/core";

@Component({
    selector: "edp-simulation-tooltip",
    templateUrl: "./edp-simulation-tooltip.component.html",
    styleUrls: ["./edp-simulation-tooltip.component.scss"]
})
export class EdpSimulationTooltipComponent {

    @Input() placement = "start";

    constructor() { }

}
